import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const workflowSchedulesObjectiveAttributes = z.object({
  system_id: optionSchema,
  part_id: optionSchema,
  action_id: optionSchema,
})

export const createWorkflowSchedulesSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho mínimo: 3 caracteres' }).max(32, { message: 'Tamanho máximo: 32 caracteres' }),
  observations: z.string({ message: 'Campo obrigatório' }).min(8, { message: 'Tamanho mínimo: 8 caracteres' }).max(128, { message: 'Tamanho máximo: 128 caracteres' }),
  kind: optionSchema,
  equipment_category_ids: optionSchema,
  branch_ids: z.array(optionSchema).optional(),
  manufacturer_ids: z.array(optionSchema).optional(),
  equipment_model_ids: z.array(optionSchema).optional(),
  equipment_ids: z.array(optionSchema).optional(),
  interval_in_days: z.string().optional(),
  interval_in_hours_usage: z.string().optional(),
  interval_in_kilometers_usage: z.string().optional(),
  objectives_attributes: z
    .array(workflowSchedulesObjectiveAttributes.merge(z.object({ id: z.string().optional() })))
    .refine((objectives) => objectives.length > 0, { message: 'Adicione pelo menos um objeto de manutenção' }),

  execution_options: z.array(optionSchema, {message: "Ao menos 1 opção é necessaria"}).min(1, "Ao menos 1 opção é necessaria")
})

export type CreateWorkflowSchedulesObjectiveSchema = z.infer<typeof workflowSchedulesObjectiveAttributes>
export type CreateWorkflowSchedulesSchema = z.infer<typeof createWorkflowSchedulesSchema>
